import * as React from 'react';
export const SOSvg = React.forwardRef(function SOSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        d: 'M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm8.08 9.785-1.723 1.036a.3.3 0 0 1-.447-.327l.457-1.905-1.545-1.443a.3.3 0 0 1 .192-.52l1.898-.083.895-1.95a.3.3 0 0 1 .546 0l.895 1.95 1.898.084a.3.3 0 0 1 .192.519L9.793 8.589l.457 1.905a.3.3 0 0 1-.447.327L8.08 9.785Z',
      }),
    ),
  );
});
SOSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var SO = {
  category: 'flag',
  colorable: false,
  name: 'SO',
  svg: SOSvg,
};
